import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../../core/reducers';
import {
  selectPractitionRolesInStore,
  selectPractitionRolesPageLoading,
  selectPractitionRolesShowInitWaitingMessage,
} from '../_selectors/practition-role.selectors';

export class PractitionRolesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();
    this.loading$ = this.store.pipe(select(selectPractitionRolesPageLoading));
    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectPractitionRolesShowInitWaitingMessage),
    );
    this.store
      .pipe(select(selectPractitionRolesInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
